module.exports = __webpack_public_path__ + "static/puppy-peeking-e0ce54d203aa0b674058728e90c64692.png";